<template>
  <div>
    <tree-node
      class="root-item"
      v-for="child in root"
      :key="getNodeKey(child)"
      :node="child"
      :layer="0"
      :node-key="nodeKey"
      @check="handleCheckEvent"
      @expandChange="handleExpandChange"
      :compound-optional="compoundOptional"
    ></tree-node>
  </div>
</template>

<script>
import TreeNode from "@/components/SelectionTree/TreeNode";
export default {
  name: "SelectionTree",
  components: { TreeNode },
  props: {
    nodeKey: {
      type: String,
      default: "id"
    },

    data: {
      type: Array,
      default: () => []
    },

    compoundOptional: {
      default: true
    },

    defaultExpandedKeys: {
      type: Array,
      default: () => []
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      root: null,
      flatDataArray: null
    };
  },

  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val) {
          return;
        }
        this.flatDataArray = [];
        this._initFlatArray(this.data);
        this.setRoot();
      }
    }
  },

  computed: {
    expandedMapper() {
      const mapper = {};
      this.defaultExpandedKeys.forEach(item => (mapper[item] = true));
      return mapper;
    },

    checkedMapper() {
      const mapper = {};
      this.defaultCheckedKeys.forEach(item => (mapper[item] = true));
      return mapper;
    }
  },

  created() {},

  methods: {
    setRoot() {
      const cache = JSON.parse(JSON.stringify(this.data));
      this._initNodeData(cache);
      this.root = cache;
    },

    getRoot() {
      return JSON.parse(JSON.stringify(this.root));
    },

    handleExpandChange(key, value, name) {
      const defaultExpandedKeys = [...this.defaultExpandedKeys];
      const indexNum = defaultExpandedKeys.indexOf(key);
      if (indexNum !== -1) {
        defaultExpandedKeys.splice(indexNum, 1);
      }
      if (value) {
        defaultExpandedKeys.push(key);
      }
      this.$emit("update:defaultExpandedKeys", defaultExpandedKeys);
      this.$emit("expandChange", key, value, name);
    },

    getCheckedNodes() {
      const checkedNodes = [];
      this._queryCheckedNodes(this.root, checkedNodes);
      return checkedNodes;
    },

    _queryCheckedNodes(array, checkedNodes) {
      for (const node of array) {
        if (!Array.isArray(node.children) && node.isChecked) {
          checkedNodes.push(
            this.flatDataArray.find(
              item => item[this.nodeKey] === node[this.nodeKey]
            )
          );
        }

        if (Array.isArray(node.children)) {
          this._queryCheckedNodes(node.children, checkedNodes);
        }
      }
    },

    clearAllChecked() {
      this.clearChecked(this.root);
    },

    clearChecked(array, checkedNodes) {
      for (const node of array) {
        if (!Array.isArray(node.children) && node.isChecked) {
          node.isChecked = false;
        }

        if (Array.isArray(node.children)) {
          this.clearChecked(node.children, checkedNodes);
        }
      }
    },

    _initFlatArray(array) {
      for (const item of array) {
        if (Object.prototype.toString.call(item) !== "[object Object]") {
          return;
        }

        if (Array.isArray(item.children)) {
          this._initFlatArray(item.children);
        }
        this.flatDataArray.push(item);
      }
    },

    _initNodeData(data, isCheck = false) {
      if (!Array.isArray(data)) {
        return;
      }
      for (const item of data) {
        if (Object.prototype.toString.call(item) !== "[object Object]") {
          return;
        }

        item.selectAllStatus = "none";
        item.isExpanded = this.expandedMapper[item[this.nodeKey]] === true;
        item.isChecked =
          isCheck || this.checkedMapper[item[this.nodeKey]] === true;
        if (Array.isArray(item.children)) {
          this._initNodeData(item.children, item.isChecked);
        }
      }
    },

    handleCheckEvent(node) {
      const native = this.flatDataArray.find(
        item => item[this.nodeKey] === node[this.nodeKey]
      );
      this.$emit("check", node.isChecked, native);
    },

    getNodeKey(node) {
      return node[this.nodeKey];
    }
  }
};
</script>

<style scoped lang="less"></style>
